import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { Rating } from "@/components/Product/Rating/rating.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";
import { formatNumber } from "@/utils/format";

export type OnlyScoreRatingSummaryProps = {
    value: number;
    count: number;
    writeReview: () => void;
    goToReviews: () => void;
};

const OnlyScoreRatingSummaryComponent = ({
    value,
    count,
    writeReview,
    goToReviews
}: OnlyScoreRatingSummaryProps) => {
    const { t } = useGranite();

    return (
        <div
            className={cn(
                "tw:inline-flex tw:flex-row tw:gap-2 tw:items-center"
            )}
        >
            <Button
                size="sm"
                color="link"
                className={cn("tw:inline-flex tw:gap-4 tw:p-0")}
                onClick={goToReviews}
            >
                <Rating
                    value={value}
                    size={16}
                />
                <span>
                    {formatNumber(value, Config.getLocale(), {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1
                    })}
                </span>
                <div>{`(${formatNumber(count, Config.getLocale())})`}</div>
            </Button>
            <div>
                <Button
                    size="sm"
                    color="link"
                    aria-label={t("general.reviews.write.aria")}
                    onClick={writeReview}
                    className={cn("tw:p-0")}
                >
                    {t("general.reviews.write")}
                </Button>
            </div>
        </div>
    );
};

export { OnlyScoreRatingSummaryComponent };
